import { z } from 'zod'

export function coerceToNumber<T>(value: T): number | T {
  let newValue = value
  // 如果 value 為字串，且開頭為多個 0，則將 0 去掉
  if (typeof newValue === 'string' && newValue.startsWith('0')) {
    newValue = newValue.replace(/^0+/, '') as T
  }

  const parsed = z.coerce.number().safeParse(newValue)

  if (parsed.success) {
    return parsed.data
  } else {
    return newValue
  }
}
